import { __spreadArray } from "tslib";
export var addBorderClasses = function (_a) {
    var showBorderLeft = _a.showBorderLeft, showBorderRight = _a.showBorderRight, isRtl = _a.isRtl;
    return __spreadArray(__spreadArray([], [
        showBorderLeft ? (isRtl ? 'show-border-right' : 'show-border-left') : '',
    ], false), [
        showBorderRight ? (isRtl ? 'show-border-left' : 'show-border-right') : '',
    ], false).join(' ');
};
//# sourceMappingURL=common.js.map